<template>
  <div class="courseDetail">
    <div class="header">
      <div class="courseimg">
        <img :src="CourseDetail.courseCover">
      </div>
      <div class="header_text">
        <h1 class="title">{{CourseDetail.courseName}}
          <el-button type="primary" style="margin-left: 20px;" @click="$refs.child.ClickADDCourse(1,CourseDetail)">修改基本信息</el-button>
          <!-- <el-button type="primary" style="margin-left: 20px;" @click="$router.push('/Education/addtestpaper?isNew=0&courseDetail=true')">新增试卷</el-button> -->
        </h1>
        <p>标签：{{CourseDetail.courseTag}}</p>
        <p class="text">{{CourseDetail.courseDescription}}</p>
        <div class="courseinfo">
          <span>{{ $t('Education.languages67') }}：<label>{{CourseDetail.hours?CourseDetail.hours:0}}课时</label></span>
          <el-button type="primary" @click="$router.push('addcourse?isNew=0&courseId='+courseId)">增加章节</el-button>
          <el-button @click="$router.go(-1)">{{ $t('Education.languages15') }}</el-button>
        </div>
        
      <el-table
          :data="examList"
          :cell-style="{'text-align':'center'}"
          style="width: 100%">
        <el-table-column prop="examTitle" label="试卷名称"></el-table-column>
        <el-table-column prop="examRadioNum" label="单选题"></el-table-column>
        <el-table-column prop="examMultipleNum" label="多选题"></el-table-column>
        <el-table-column prop="examQuestionNum" label="问答题"></el-table-column>
        <el-table-column prop="createBy" label="最近更新者"></el-table-column>
        <el-table-column prop="createTime" label="更新时间"></el-table-column>
        <el-table-column :label="$t('Education.languages42')">
          <template v-slot="scope">
            <span class="operateitem" @click="$router.push('addtestpaper?isNew=1&examId='+scope.row.examId)">维护试卷</span>
          </template>
        </el-table-column>
      </el-table>
      </div>
    </div>

    <div class="content">
      <el-table
          :data="CourseDetail.chapters"
          :cell-style="{'text-align':'center'}"
          style="width: 100%">
        <el-table-column prop="chapterName" label="章节主题"></el-table-column>
        <el-table-column prop="chapterOrder" label="章节序号"></el-table-column>
        <el-table-column prop="chapterHours" label="课时数"></el-table-column>
        <el-table-column prop="teacherName" label="培训老师"></el-table-column>
        <el-table-column prop="createBy" label="上传人"></el-table-column>
        <el-table-column prop="createTime" label="上传时间"></el-table-column>
        <el-table-column label="视频时长">
          <template v-slot="scope">
            {{scope.row.chapterVideoHours?Math.floor(scope.row.chapterVideoHours/60)+"分"+scope.row.chapterVideoHours%60+'秒':0}}
          </template>
        </el-table-column>
        <el-table-column prop="liveConferenceCode" label="会议号"></el-table-column>
        <el-table-column prop="liveLinkAddress" label="直播地址"></el-table-column>
        <el-table-column :label="$t('Education.languages42')">
          <template v-slot="scope">
            <el-popconfirm
              @confirm="Deletechapter(scope.row)"
              title="是否确定删除？"
            >
              <span class="operateitem" slot="reference">{{ $t('Education.languages07') }}</span>
            </el-popconfirm>
            <span class="operateitem" @click="$router.push('addcourse?isNew=1&chapterId='+scope.row.chapterId)">{{ $t('Education.languages08') }}</span>
            <span class="operateitem" @click="$router.push('addcourse?isNew=2&chapterId='+scope.row.chapterId)">{{ $t('Education.languages09') }}</span>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <!-- 课程基本信息 -->
    <ADDCourse ref="child"></ADDCourse>
  </div>
</template>

<script>
import ADDCourse from './component/ADDCourse.vue'
export default ({
  name:'courseDetail',
  data(){
    return{
      courseId:this.$route.query.courseId,
      CourseDetail:[],
      examList:[]
    }
  },
  created() {
    this.CourseList();
  },
  mounted() {
  },
  methods:{
    CourseList(){
      this.examList=[];
      this.$Http_Get('/edu/course/getInfo/'+this.courseId).then(res=>{
        if(res.Code==0){
          this.CourseDetail=res.Data;
          if(res.Data.exam!=null){
            this.examList.push(res.Data.exam);
          }
        }else{
          this.$message({type: 'error', message: res.Message})
        }
      })
    },

    //删除章节
    Deletechapter(val){
      this.$Http_Post('edu/chapter/remove/'+val.chapterId).then(res=>{
        if(res.Code==0){
          this.$message({type: 'success', message: res.Message});
          this.CourseList();
        }else{
          this.$message({type: 'error', message: res.Message})
        }
      });
    },
  },
  components:{
    ADDCourse
  }
})
</script>
<style scoped>
.header{display: flex;background:#fff;padding: 30px 30px 0;}
.content{background:#fff;padding:30px;}
.operateitem{padding: 0 5px 0 0;}
.courseimg{width:330px;height:330px;overflow: hidden;display: grid;}
.courseimg img{width: 100%;display: block;height:100%;}
.header_text{display: inline-block;padding:10px 30px;position: relative;width: -webkit-fill-available;}
.header_text .title{font-size: 26px;}
.header_text .text{margin:10px 0;font-size: 16px;color: #333;overflow: hidden; text-overflow: ellipsis; width: 100%;display: -webkit-box;-webkit-box-orient: vertical;-webkit-line-clamp: 3; word-break: break-all;}
.header_text .courseinfo{position: absolute;bottom:0;left:30px;font-size: 16px;font-weight: bold;}
.header_text .courseinfo span{padding-right: 30px;}
.header_text .courseinfo label{font-weight: 400;}
.operateitem{color: #0088ff;cursor: pointer;}
.el-form-item{margin-bottom:0;}
i{color: red;padding:0 5px;}
</style>